import styled from '@emotion/styled';

export const AnswerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 8px;
  padding-left: 39px;
`;

export const UserIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  position: relative;
  border-radius: 999px;
  background: #23252a;
  border: 1px solid #2b2d33;
`;

export const UserIconText = styled.span`
  font-family: 'Inter', sans-serif;
  color: #e9ecf5;
`;

export const AnswerContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 6px;
  padding: 12px;
  border-radius: 12px;
  background: #23252a;
  border: 1px solid #2b2d33;
`;

export const AnswerText = styled.p`
  font-family: Inter, sans-serif;
  line-height: 150%;
  margin: 0;
  font-size: 14px;
  color: #e9ecf5;
`;

export const AnswerMeta = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const AnswerMetaText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #b7bdcb;
`;
